<template>
    <v-row dense>
        <v-col cols="12" md="4" lg="4">
            <v-img
                :src="$store.state.backend_url+set_book.image"
                class="ma-2"
                max-width="300px"
            ></v-img>
        </v-col>
        <v-col cols="12" md="8" lg="8">
            <v-list-item>
                <v-list-item-content>
                    <v-list-item-subtitle>
                        {{ set_book.title }}
                    </v-list-item-subtitle>
                </v-list-item-content>
            </v-list-item>
            <v-divider class="mx-2" />
            <v-list-item>
                <v-row>
			<v-col cols="12">
				<div v-html="contentQuill"></div>
			</v-col>
		</v-row>
            </v-list-item>
            <v-list-item>
                <v-list-item-action>
                    <template v-if="set_book.external_link!=null">
                        <a :href="set_book.external_link" target="_blank">
                            <v-btn small outlined>
                                구매링크
                            </v-btn>
                        </a>
                    </template>
                </v-list-item-action>
            </v-list-item>
        </v-col>
        <v-divider class="mx-2" />
        <v-col cols="12">
            <v-list>
                <v-list-item v-for="post in set_book.related_posts" :key="post.id">
                    <v-list-item-content>
                        <v-list-item-subtitle @click="$router.push({name: 'home', params: { postParams : post }})">
                            {{ post.title }}
                        </v-list-item-subtitle>
                    </v-list-item-content>
                </v-list-item>
            </v-list>
        </v-col>
    </v-row>
</template>
<script>
import axios from 'axios'
  export default {
    data: () => ({
      formData: {
        title: '',
        content_with_images: '',
    
        // 다른 필드들에 대한 초기값도 추가할 수 있습니다.
      },
    }),
    props:['set_book'],
    mounted(){
    },
    methods:{
        
    },
    computed:{
        contentQuill() {
                var html_content = this.set_book.content.replace(/(\n|\r\n)/g, "<br/>")
                html_content = html_content.replace(/<img/g, '<img class="responsive-image" ');
                return html_content
        },
    }   

  }
</script>
